var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSalesTools2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_244_14959)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 72C55.8823 72 72 55.8835 72 36C72 16.1165 55.8823 0 36 0C16.1177 0 0 16.1165 0 36C0 55.8835 16.1177 72 36 72Z",
    fill: "#F2F4FA"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_244_14959)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.8408 13.6526V60.2222C68.8408 61.7659 67.5698 63.0388 66.0262 63.0388H5.9787C4.43506 63.0388 3.16406 61.7659 3.16406 60.2222V13.6526C3.16406 12.1089 4.43506 10.8359 5.9787 10.8359H66.0262C67.5698 10.8359 68.8408 12.1089 68.8408 13.6526Z",
    fill: "url(#paint0_linear_244_14959)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M68.8408 13.6565V15.7013H3.16406V13.6565C3.16406 12.1128 4.43506 10.8398 5.9787 10.8398H66.0262C67.5698 10.8398 68.8408 12.1128 68.8408 13.6565Z",
    fill: "url(#paint1_linear_244_14959)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.1129 14.1577C6.58902 14.1577 6.9752 13.7718 6.9752 13.2937C6.9752 12.8156 6.58902 12.4297 6.1129 12.4297C5.6362 12.4297 5.25 12.8156 5.25 13.2937C5.25 13.7718 5.6362 14.1577 6.1129 14.1577Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M8.79255 14.1577C9.26867 14.1577 9.65489 13.7718 9.65489 13.2937C9.65489 12.8156 9.26867 12.4297 8.79255 12.4297C8.31586 12.4297 7.92969 12.8156 7.92969 13.2937C7.92969 13.7718 8.31586 14.1577 8.79255 14.1577Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M11.5147 14.1577C11.9914 14.1577 12.3776 13.7718 12.3776 13.2937C12.3776 12.8156 11.9914 12.4297 11.5147 12.4297C11.0386 12.4297 10.6523 12.8156 10.6523 13.2937C10.6523 13.7718 11.0386 14.1577 11.5147 14.1577Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6314 20.6484V57.4894H8.93359V20.6484H63.6314Z",
    stroke: "#C2C8D6",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.95312 29.5664H63.3996",
    stroke: "#C2C8D6",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.95312 38.5156H63.3996",
    stroke: "#C2C8D6",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.95312 48.0898H63.3996",
    stroke: "#C2C8D6",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0938 20.6484V57.4894",
    stroke: "#C2C8D6",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6953 20.6484V57.4894",
    stroke: "#C2C8D6",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8633 20.6484V57.4894",
    stroke: "#C2C8D6",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0234 20.6484V57.4894",
    stroke: "#C2C8D6",
    strokeWidth: 1.33333,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0984 30.1406H32.1975C31.8792 30.1406 31.6211 30.3985 31.6211 30.7166V32.3553C31.6211 32.6734 31.8792 32.9313 32.1975 32.9313H41.0984C41.4168 32.9313 41.6749 32.6734 41.6749 32.3553V30.7166C41.6749 30.3985 41.4168 30.1406 41.0984 30.1406Z",
    fill: "#7D63EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3094 21.207H10.4084C10.0901 21.207 9.83203 21.4649 9.83203 21.783V23.4217C9.83203 23.7399 10.0901 23.9977 10.4084 23.9977H19.3094C19.6277 23.9977 19.8858 23.7399 19.8858 23.4217V21.783C19.8858 21.4649 19.6277 21.207 19.3094 21.207Z",
    fill: "#7D63EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9217 44.0938H10.4084C10.0901 44.0938 9.83203 44.3516 9.83203 44.6698V46.3085C9.83203 46.6266 10.0901 46.8845 10.4084 46.8845H29.9217C30.24 46.8845 30.4981 46.6266 30.4981 46.3085V44.6698C30.4981 44.3516 30.24 44.0938 29.9217 44.0938Z",
    fill: "#21C4C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0984 33.4844H32.1975C31.8792 33.4844 31.6211 33.7423 31.6211 34.0604V36.8154C31.6211 37.1335 31.8792 37.3914 32.1975 37.3914H41.0984C41.4168 37.3914 41.6749 37.1335 41.6749 36.8154V34.0604C41.6749 33.7423 41.4168 33.4844 41.0984 33.4844Z",
    fill: "#21C4C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9266 30.1406H21.5842C21.2659 30.1406 21.0078 30.3985 21.0078 30.7166V33.4716C21.0078 33.7897 21.2659 34.0476 21.5842 34.0476H29.9266C30.245 34.0476 30.503 33.7897 30.503 33.4716V30.7166C30.503 30.3985 30.245 30.1406 29.9266 30.1406Z",
    fill: "#7D63EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2703 21.207H43.3694C43.051 21.207 42.793 21.4649 42.793 21.783V24.538C42.793 24.8561 43.051 25.114 43.3694 25.114H52.2703C52.5887 25.114 52.8467 24.8561 52.8467 24.538V21.783C52.8467 21.4649 52.5887 21.207 52.2703 21.207Z",
    fill: "#7D63EC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M54.5195 22.8819C54.828 22.8819 55.078 22.632 55.078 22.3238C55.078 22.0155 54.828 21.7656 54.5195 21.7656C54.211 21.7656 53.9609 22.0155 53.9609 22.3238C53.9609 22.632 54.211 22.8819 54.5195 22.8819Z",
    fill: "#C2C8D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8826 33.4844H43.3694C43.051 33.4844 42.793 33.7423 42.793 34.0604V36.8154C42.793 37.1335 43.051 37.3914 43.3694 37.3914H62.8826C63.2009 37.3914 63.459 37.1335 63.459 36.8154V34.0604C63.459 33.7423 63.2009 33.4844 62.8826 33.4844Z",
    fill: "#7D63EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1249 22.8819C22.4334 22.8819 22.6835 22.632 22.6835 22.3238C22.6835 22.0155 22.4334 21.7656 22.1249 21.7656C21.8165 21.7656 21.5664 22.0155 21.5664 22.3238C21.5664 22.632 21.8165 22.8819 22.1249 22.8819Z",
    fill: "#C2C8D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1249 31.8116C22.4334 31.8116 22.6835 31.5617 22.6835 31.2535C22.6835 30.9452 22.4334 30.6953 22.1249 30.6953C21.8165 30.6953 21.5664 30.9452 21.5664 31.2535C21.5664 31.5617 21.8165 31.8116 22.1249 31.8116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1249 40.7452C22.4334 40.7452 22.6835 40.4953 22.6835 40.187C22.6835 39.8788 22.4334 39.6289 22.1249 39.6289C21.8165 39.6289 21.5664 39.8788 21.5664 40.187C21.5664 40.4953 21.8165 40.7452 22.1249 40.7452Z",
    fill: "#C2C8D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1249 50.2335C22.4334 50.2335 22.6835 49.9836 22.6835 49.6753C22.6835 49.3671 22.4334 49.1172 22.1249 49.1172C21.8165 49.1172 21.5664 49.3671 21.5664 49.6753C21.5664 49.9836 21.8165 50.2335 22.1249 50.2335Z",
    fill: "#C2C8D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9531 22.8819C11.2615 22.8819 11.5116 22.632 11.5116 22.3238C11.5116 22.0155 11.2615 21.7656 10.9531 21.7656C10.6446 21.7656 10.3945 22.0155 10.3945 22.3238C10.3945 22.632 10.6446 22.8819 10.9531 22.8819Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9531 31.8116C11.2615 31.8116 11.5116 31.5617 11.5116 31.2535C11.5116 30.9452 11.2615 30.6953 10.9531 30.6953C10.6446 30.6953 10.3945 30.9452 10.3945 31.2535C10.3945 31.5617 10.6446 31.8116 10.9531 31.8116Z",
    fill: "#C2C8D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9531 40.7452C11.2615 40.7452 11.5116 40.4953 11.5116 40.187C11.5116 39.8788 11.2615 39.6289 10.9531 39.6289C10.6446 39.6289 10.3945 39.8788 10.3945 40.187C10.3945 40.4953 10.6446 40.7452 10.9531 40.7452Z",
    fill: "#C2C8D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9531 50.2335C11.2615 50.2335 11.5116 49.9836 11.5116 49.6753C11.5116 49.3671 11.2615 49.1172 10.9531 49.1172C10.6446 49.1172 10.3945 49.3671 10.3945 49.6753C10.3945 49.9836 10.6446 50.2335 10.9531 50.2335Z",
    fill: "#C2C8D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7382 22.8819C33.0467 22.8819 33.2968 22.632 33.2968 22.3238C33.2968 22.0155 33.0467 21.7656 32.7382 21.7656C32.4298 21.7656 32.1797 22.0155 32.1797 22.3238C32.1797 22.632 32.4298 22.8819 32.7382 22.8819Z",
    fill: "#C2C8D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7382 31.8116C33.0467 31.8116 33.2968 31.5617 33.2968 31.2535C33.2968 30.9452 33.0467 30.6953 32.7382 30.6953C32.4298 30.6953 32.1797 30.9452 32.1797 31.2535C32.1797 31.5617 32.4298 31.8116 32.7382 31.8116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7382 40.7452C33.0467 40.7452 33.2968 40.4953 33.2968 40.187C33.2968 39.8788 33.0467 39.6289 32.7382 39.6289C32.4298 39.6289 32.1797 39.8788 32.1797 40.187C32.1797 40.4953 32.4298 40.7452 32.7382 40.7452Z",
    fill: "#C2C8D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7382 50.2335C33.0467 50.2335 33.2968 49.9836 33.2968 49.6753C33.2968 49.3671 33.0467 49.1172 32.7382 49.1172C32.4298 49.1172 32.1797 49.3671 32.1797 49.6753C32.1797 49.9836 32.4298 50.2335 32.7382 50.2335Z",
    fill: "#C2C8D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0781 22.8819C55.3865 22.8819 55.6366 22.632 55.6366 22.3238C55.6366 22.0155 55.3865 21.7656 55.0781 21.7656C54.7696 21.7656 54.5195 22.0155 54.5195 22.3238C54.5195 22.632 54.7696 22.8819 55.0781 22.8819Z",
    fill: "#C2C8D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0781 31.8116C55.3865 31.8116 55.6366 31.5617 55.6366 31.2535C55.6366 30.9452 55.3865 30.6953 55.0781 30.6953C54.7696 30.6953 54.5195 30.9452 54.5195 31.2535C54.5195 31.5617 54.7696 31.8116 55.0781 31.8116Z",
    fill: "#C2C8D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0781 40.7452C55.3865 40.7452 55.6366 40.4953 55.6366 40.187C55.6366 39.8788 55.3865 39.6289 55.0781 39.6289C54.7696 39.6289 54.5195 39.8788 54.5195 40.187C54.5195 40.4953 54.7696 40.7452 55.0781 40.7452Z",
    fill: "#C2C8D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0781 50.2335C55.3865 50.2335 55.6366 49.9836 55.6366 49.6753C55.6366 49.3671 55.3865 49.1172 55.0781 49.1172C54.7696 49.1172 54.5195 49.3671 54.5195 49.6753C54.5195 49.9836 54.7696 50.2335 55.0781 50.2335Z",
    fill: "#C2C8D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9062 22.8819C44.2147 22.8819 44.4647 22.632 44.4647 22.3238C44.4647 22.0155 44.2147 21.7656 43.9062 21.7656C43.5977 21.7656 43.3477 22.0155 43.3477 22.3238C43.3477 22.632 43.5977 22.8819 43.9062 22.8819Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9062 31.8116C44.2147 31.8116 44.4647 31.5617 44.4647 31.2535C44.4647 30.9452 44.2147 30.6953 43.9062 30.6953C43.5977 30.6953 43.3477 30.9452 43.3477 31.2535C43.3477 31.5617 43.5977 31.8116 43.9062 31.8116Z",
    fill: "#C2C8D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9062 40.7452C44.2147 40.7452 44.4647 40.4953 44.4647 40.187C44.4647 39.8788 44.2147 39.6289 43.9062 39.6289C43.5977 39.6289 43.3477 39.8788 43.3477 40.187C43.3477 40.4953 43.5977 40.7452 43.9062 40.7452Z",
    fill: "#C2C8D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9062 50.2335C44.2147 50.2335 44.4647 49.9836 44.4647 49.6753C44.4647 49.3671 44.2147 49.1172 43.9062 49.1172C43.5977 49.1172 43.3477 49.3671 43.3477 49.6753C43.3477 49.9836 43.5977 50.2335 43.9062 50.2335Z",
    fill: "#C2C8D6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_244_14959",
    x: -7.5026,
    y: 7.28038,
    width: 87.0091,
    height: 73.5365,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7.11111
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.33333
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_244_14959"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_244_14959",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_244_14959",
    x1: 35.9811,
    y1: 9.6321,
    x2: 35.9811,
    y2: 63.5975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_244_14959",
    x1: 66.2354,
    y1: 10.8398,
    x2: 5.30103,
    y2: 13.7124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_244_14959"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesTools2);
export default __webpack_public_path__ + "static/media/sales-tools-2.faca3560addc4ecab7d9f2137db9d712.svg";
export { ForwardRef as ReactComponent };